import React from "react";
import { Box, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import WorkTotalBox from "./WorkTotalBox";

function WorkTotalBoxSection({ workData }) {
  return (
    <Columns isMultiline>
      <Column>
        <Box>
          <Title size="5">Total Supplier Costs</Title>
          <WorkTotalBox
            labourTotal={workData.total_labour}
            partsTotal={workData.total_part_cost}
          />
        </Box>
      </Column>
      <Column>
        <Box>
          <Title size="5">Total Chargeable</Title>
          <WorkTotalBox
            labourTotal={workData.total_chargeable_customer_labour}
            partsTotal={workData.total_chargeable_customer_part_cost}
          />
        </Box>
      </Column>
    </Columns>
  );
}

export default WorkTotalBoxSection;
